<template>
  <div class="tableSonTemp">
    <div v-if="data">
      <div class="ellipsisStyle">
        <template v-if="data.length > 0">
          <el-dropdown @command="commandFun">
            <span style="cursor: pointer"
              ><i class="el-icon-document elOpStyle"></i>查看文件</span
            >
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="index"
                v-for="(item, index) in data"
                :key="index"
                >{{ item.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <span v-else>-</span>
      </div>
    </div>
    <span v-else>-</span>
    <PreviewCom
      :show.sync="dialogVisible"
      :url="dialogImageUrl"
      :urlList="data"
    ></PreviewCom>
  </div>
</template>
<script>
export default {
  props: ["data", "config"],

  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
    };
  },
  methods: {
    // 文件下载
    commandFun(index) {
      let url = this.$operateUrl(this.data[index].url);
      if (!this.$chargeImg(this.data[index].name, this.data[index].fileType)) {
        // pdf直接查看
        if (this.data[index].name.includes("pdf")) {
          window.open(url);
        }
        this.$downLoadFn(this.data[index].name, url);
      } else {
        this.dialogImageUrl = url;
        this.dialogVisible = true;
      }
    },
  },
};
</script>
